import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { DefaultLayout2 } from '@web/app/shared';

import { useWebCoreStore } from '@codes/web-core';

import { PublicLayout } from '../components/PublicLayout';
import { ShowCatalogDetailPage } from '../pages/ShowCatalogDetailPage';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const ShowCatalogRoutes = () => {
    const isAuthenticated = useWebCoreStore(state => state.isAuthenticated);
    const { i18n } = useTranslation();
    const Layout = isAuthenticated ? DefaultLayout2 : PublicLayout;

    // 비로그인 상태에서 언어 설정이 없으면 한국어를 기본으로
    useEffect(() => {
        if (!isAuthenticated && i18n.language === 'en') {
            const hasUserLanguageSetting = Object.keys(localStorage).some(key => key.includes('LANGUAGE'));
            if (!hasUserLanguageSetting) {
                i18n.changeLanguage('ko');
            }
        }
    }, [isAuthenticated, i18n]);

    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route element={<Layout />}>
                    <Route path=":catalogId" element={<ShowCatalogDetailPage />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            </Routes>
        </>
    );
};
